webpackJsonp([273950069227526],{

/***/ 378:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Jorge Mancheno, Product Designer"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---about-2f6ebcbfa36480ebb5e9.js